
import {
    toLakh,
    sumThis,
    numberWithCommas,
    toCurrency,
    sumOf,
    countOf,
    sumAndCountOf,
    showSum,
    showCount,
    showSumAndCount,
    percentChange,
    showBlank,
    changeClassTo,
    mobileNumber,
    panCardNumber,
    validEmail,
    adharNumber,
    allDirectQueries
  } from "../commonFunctions";
  
  const subadminlive2 = {
    label: "P Vol Reporting",
    pageLabel: "P Vol Reporting",
    starting: true,
    url: "subadminlive2",
    pageType: "history",
    form: [
        {
            inputType: "displaytext",
            
            widths: {
              parent: "col-lg-2",
              children: "col-lg-12"
            },
            label: "Booth",
            description: ""
          },
          {
              inputType: "text",
            //   read
            
              widths: {
                parent: "col-lg-3",
                children: "col-lg-12"   
            },
            name:"booth",
            placeHolder: "Booth",
            description: ""
          },
    {
        inputType: "displaytext",
        
        widths: {
          parent: "col-lg-2",
          children: "col-lg-12"
        },
        label: "Total Voters",
        description: ""
      },
      {
          inputType: "text",
        //   read
          isReadOnly : "true",
          widths: {
            parent: "col-lg-3",
            children: "col-lg-12"   
        },
        name:"TotalVoters",
        placeHolder: "Total Voters",
        description: ""
      },
      {
        inputType: "displaytext",
        
        widths: {
          parent: "col-lg-2",
          children: "col-lg-12"
        },
        label: "",
        description: ""
      },
      {
        inputType: "displaytext",
        
        widths: {
          parent: "col-lg-2",
          children: "col-lg-12"
        },
        label: "Voted Count",
        description: ""
      },
      {
        inputType: "text",
        //   read
          isReadOnly : "true",
          widths: {
            parent: "col-lg-3",
            children: "col-lg-12"
        },
        name:"Voted",
        placeHolder: "Total Voted",
        description: ""
      },
      {
        inputType: "displaytext",
        
        widths: {
          parent: "col-lg-2",
          children: "col-lg-12"
        },
        label: "Non Voted Count",
        description: ""
      },
      {
          inputType: "text",
        //   read
          isReadOnly : "true",
          widths: {
            parent: "col-lg-3",
            children: "col-lg-12"
        },
        name:"NonVoted",
        placeHolder: "Total NonVoted",
        description: ""
      },
      {
        inputType: "displaytext",
        
        widths: {
          parent: "col-lg-2",
          children: "col-lg-12"
        },
        label: "",
        description: ""
      },
      {
        inputType: "displaytext",
        
        widths: {
          parent: "col-lg-2",
          children: "col-lg-12"
        },
        label: "Voted Percentage",
        description: ""
      },
      {
        inputType: "text",
        //   read
          isReadOnly : "true",
          widths: {
            parent: "col-lg-3",
            children: "col-lg-12"
        },
        name:"percentage",
        placeHolder: "Total Percent",
        description: ""
      },
      {
        inputType: "button",
        widths: {
          parent: "col-lg-2",
          children: "col-lg-12"
        },
        placeHolder: "",
        label: "Load",
        Bcolor: "primary",
        size: "md",
        style: null,
        getHotname:"pvolnameWiseReporting",
        onclick: {
          action: "loadallRecords",
          // requiredValue:['srno','VoterID','VoterName','mobilenumber1','livingoutstation','FamilyHead','EvolName','PvolName','EvolMobNo'],
          
          // parameters: {
          //   contenttype: "file",
          //   filename: { type: "form", key: "referencefile" }
          // },
          
          loadinto: "AllData"
        },
        description: "Load Election Records"
      },
     
      {
        inputType: "button",
        widths: {
          parent: "col-lg-3",
          children: "col-lg-12"
        },
        placeHolder: "",
        label: "Click for Non Voted List",
        Bcolor: "primary",
        size: "md",
        style: null,
        getHotname:"nonvoters",
        onclick: {
          action: "nonvoterlist",
          requiredValue:['srno','VoterID','VoterName','EvolName','EvolMobNo','PvolName','mobilenumber1','livingoutstation','FamilyHead'],
                    // parameters: {
          //   contenttype: "file",
          //   filename: { type: "form", key: "referencefile" }
          // },
          
          loadinto: "nonvoters"
        },
        description: ""
      },
      {
        inputType: "handsonTable",
        widths: {
          parent: "col-lg-12",
          children: "col-lg-12"
        },
        // headers:["Car", "Model", "Number", "Date"],
        // data:[],
        label: "Non Voters",
        name: "nonvoters",
        description: "Select Voted Status",
        
        // getHotname:"reporting",
        tableOptions: {
          // validations, basic calculations, colors, date pickers, context menu etc.
          // Srno, VoterID, Name ,Mobile No(Voter), OutStation, FamilyHead, EvolName, PvolName, EvolMobNo
          HOTheaders: [
            "Sr No",
            "Voter ID",
            "Name","E Volunteer","E Vol Mobile","P Volunteer","Own Mobile","Outstation","Family Head" 
          ],
          columns: [
            { type: "text" },
            { type: "text" },
            { type: "text" },
            { type: "text" },
            { type: "text" },
            { type: "text" },                
            { type: "text" },
            { type: "text" },
            { type: "text" },
            
          ],
          // rowHeaders: true,
          contextMenu: true,
          minSpareRows: 1,
          width: 1200,
          height: 400,
          stretchH: "all",
          columnSorting: true,
          autoWrapRow: true,
          maxRows: 100,
          manualRowResize: true,
          manualColumnResize: true,
          headerTooltips: true
          // nestedHeaders: [
          //   ['Item', {label: 'Vendor 1', colspan: 3}, {label: 'Vendor 2', colspan: 3}],
          //   // ['D', {label: 'E', colspan: 4}, {label: 'F', colspan: 4}, 'G'],
          //   // ['H', {label: 'I', colspan: 2}, {label: 'J', colspan: 2}, {label: 'K', colspan: 2}, {label: 'L', colspan: 2}, 'M'],
          //   ['Item', 'Q', 'R', 'P', 'Q', 'R', 'P']
          // ],
        }
      },

    {
        widths: "col-lg-12",
        subComponents: [
          {
            inputType: "handsonTable",
            widths: {
              parent: "col-lg-12",
              children: "col-lg-12"
            },
            // headers:["Car", "Model", "Number", "Date"],
            // data:[],
            label: "PvolName Wise Reporting",
            name: "pvolnameWiseReporting",
            description: "PvolName Wise",
            // reduiredValue:['srno','firstName','middleName','lastName','VoterID','circle.value','subCircle.value','village.value',"mobilenumber1"],
            // getHotname:"reporting",
            tableOptions: {
              // validations, basic calculations, colors, date pickers, context menu etc.
              HOTheaders: [
                "PvolName",
                "Mobile",
                "Total Voters",
                "Voted", 
                "Non Voted",
                "Voted %",
                "Out Station",
                "Voted ",
                "Non Voted",
              ],
              columns: [
                { type: "text" },
                { type: "text" },
                { type: "text" },
                { type: "text" },
                { type: "text" },
                { type: "text" },                
                { type: "text" },
                { type: "text" },
                { type: "text" },
                
              ],
              // rowHeaders: true,
              contextMenu: true,
              minSpareRows: 1,
              width: 1200,
              height: 400,
              stretchH: "all",
              columnSorting: true,
              autoWrapRow: true,
              maxRows: 100,
              manualRowResize: true,
              manualColumnResize: true,
              headerTooltips: true
              // nestedHeaders: [
              //   ['Item', {label: 'Vendor 1', colspan: 3}, {label: 'Vendor 2', colspan: 3}],
              //   // ['D', {label: 'E', colspan: 4}, {label: 'F', colspan: 4}, 'G'],
              //   // ['H', {label: 'I', colspan: 2}, {label: 'J', colspan: 2}, {label: 'K', colspan: 2}, {label: 'L', colspan: 2}, 'M'],
              //   ['Item', 'Q', 'R', 'P', 'Q', 'R', 'P']
              // ],
            }
          },


        ],
    },
    
    {
        widths: "col-lg-12",
        subComponents: [
            {
                inputType: "displaytext",
                
                widths: {
                  parent: "col-lg-12",
                  children: "col-lg-12"
                },
                label: "Pie Chart",
                description: "Pie Chart"
            },
            {
                inputType: "displaytext",
                
                widths: {
                  parent: "col-lg-12",
                  children: "col-lg-12"
                },
                label: "Age Wise",
                description: "Age Wise"
            },
            {
                inputType: "displaytext",
                
                widths: {
                  parent: "col-lg-12",
                  children: "col-lg-12"
                },
                label: "Caste Wise",
                description: "Caste Wise"
            },
        ],
    },
    {
        widths: "col-lg-12",
        subComponents: [
            {
                inputType: "displaytext",
                
                widths: {
                  parent: "col-lg-12",
                  children: "col-lg-12"
                },
                label: "Line Graph",
                description: "Line Graph"
            },
        ],
    },








               

         
    ],
    history: {
      perPage: 10,
      displayColumns: [
        // {
        //   Header: "Booth No.",
        //   accessor: "boothno",
        // },
        {
          Header: "Booth Number",
          accessor: "boothno.value",
        },
        // {
        //   Header: "P-Volunteer",
        //   accessor: "pvolunteer",
        // },
        // {
        //   Header: "E-Volunteer",
        //   accessor: "evolunteer",
        // },
       
      ]
    },
  report: {
      perPage: 10,
      queryType: "mysqlQuery",
      //   groupBy: ["schedule","subschedule"],
      query: [
        {
          dialect: "mysql",
          seq: 1,
          columnHeader: [
            {
              id: "balance1",
              headerText: "trdate",
              headerFrom: "balance"
            }
          ],
          query: ""
        }
      ],
      displayColumns: [
        
        
      ]
    }
  }
  export default subadminlive2;